import React from "react";
import Layouts from "../../Components/Layouts/Layouts";
import Section1 from "./Section1.js";
import "../../styles/ContactStyle.css";
import { Helmet } from "react-helmet-async";

function Contact() {
  return (
    <>
      <Helmet>
        <title>Contact Us | Martial Arts Seminars & Training Support</title>

        <meta
          name="description"
          content="Contact Spectacular Seminars for questions about martial arts seminars, event registrations, training workshops, tournaments, or instructor programs. We're here to help."
        />

        <meta
          name="keywords"
          content="contact spectacular seminars, martial arts support, seminar registration help, martial arts events contact, training support, karate seminar contact, taekwondo events support, MMA workshop contact"
        />
      </Helmet>
      <Layouts>
        <Section1 />
      </Layouts>
    </>
  );
}
export default Contact;
